export default "__VITE_ASSET__DJScCS_m__"